package org.molap.json

import org.molap.dataframe.DataFrame
import org.molap.dataframe.JsonDataFrame

actual fun DataFrame.Companion.readJson(json: String): DataFrame<Int, String, Any?> {
    // An array of objects, or an object with such an array as "data"
    return readJson(JSON.parse<Any?>(json))
}

fun DataFrame.Companion.readJson(json: Any?): DataFrame<Int, String, Any?> {
    if(json is String) {
        return JsonDataFrame(json)
    } else if(json is Array<*>) {
        return JsonDataFrame(json as Array<Any?>)
    } else {
        return JsonDataFrame((json.asDynamic().data as Array<Any?>))
    }
}
